// globals $f
const SELECTOR = '[data-toggle="lightbox"]';

class Lightbox {
  constructor() {
    if ($(SELECTOR)) {
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
      var thisID = this.id;
      event.preventDefault();
      $(this).ekkoLightbox({
        onHide: function() {
          var today = new Date();

          var currentDateYMD =
            today.getFullYear() +
            '-' +
            (today.getMonth() + 1) +
            '-' +
            today.getDate();
          var currentDateDMY =
            today.getDate() +
            '/' +
            (today.getMonth() + 1) +
            '/' +
            today.getFullYear();
          document.getElementById(
            'user_profiles_attributes_seller_attributes_properties_attributes_' +
              thisID
          ).value = currentDateYMD;
          $('#status_' + thisID).fadeOut(300, function() {
            $(this)
              .html('<b>Status: </b><span class="value"> Watched</span>')
              .fadeIn(300);
          });

          $('#watched_on_' + thisID).fadeOut(300, function() {
            $(this)
              .html('<b>Last watched on: </b>' + currentDateDMY)
              .fadeIn(300);
          });
        },

        onShown: function() {
          var player = $f($('iframe')[0]);
          player.addEvent('ready', function() {
            player.addEvent('finish', function() {
              return $('[aria-label="Close"]').click();
            });
          });
        }
      });
    });
  }
}

export default Lightbox;



// WEBPACK FOOTER //
// ./src/javascripts/Lightbox.js